import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { QuoteState } from '@nibtravel/shared/data-access/quote';
import { OptionsSelector } from './options.selector';

/**
 * OptionsFacade - use facade pattern to easily mock within the components
 */
@Injectable({ providedIn: 'root' })
export class OptionsFacade {
  basicOptions$: Observable<any> = this.store.select(
    OptionsSelector.getBasicOptions
  );

  planId$: Observable<number | undefined> = this.store.select(
    QuoteState.planId
  );

  constructor(private store: Store) {}
}
